import React from "react";

function PlanTask({ color = "white",  height = "1rem" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      height={height}
      viewBox={`0 0 512 512`}
    >
      <path d="M448 160H320V128H448v32zM48 64C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zM448 352v32H192V352H448zM48 288c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48z" />
    </svg>
  );
}

export default PlanTask;
